import React from 'react';
import {
  Modal,
  ModalBody
} from "reactstrap";
import { useTranslation } from "react-i18next";

const MultiLawModal = ({show, setShow, messages = [], setMessages}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={show} centered={true} size="md">
        <ModalBody className="py-3 px-5">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4 className="d-flex justify-content-start text-danger mb-3">
              {t("Multiple Law Detected")}
            </h4>
            <ul className="d-flex flex-column justify-content-start">
              {messages?.map((item) => {
                return <li>{item}</li>
              })}
            </ul>
          </div>

          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button
              type="button"
              className="btn w-sm btn-light"
              onClick={() => {
                setShow(false); 
                setMessages([]);
              }}
            >
              {t("Close")}
            </button>
          </div>
        </ModalBody>
    </Modal>
  )
}

export default MultiLawModal
